import ServiceDetailPage from "@/components/ServiceDetailPage";

const WebDev = () => <ServiceDetailPage pageKey="webDev" />;

export default WebDev;
